import { Col, Radio, Row } from "antd";
import React, { useState } from "react";
import Footer from "../../../../components/common/Footer";
import PageHeading from "../../../../components/common/PageHeading";
import { Select } from "antd";
import SubHeading from "../../../../components/common/SubHeading";
import { Table, Button, Input, Form } from "antd";
import {
  DownOutlined,
  LoadingOutlined,
  UpOutlined,
} from "@ant-design/icons";
import "./tags.css";

import RightBar from "../../../../components/common/RightBar";

const { Search } = Input;
const { Option } = Select;
const Tags = () => {
  const dataSourceJack = [
    {
      key: "1",
      name: "dryer",
      usage: "2",
    },
    {
      key: "2",
      name: "Oven/range",
      usage: "6",
    },
    {
      key: "3",
      name: "refrigerator",
      usage: "2",
    },
    {
      key: "4",
      name: "washer",
      usage: "8",
    },
  ];
  const dataSourceLucy = [
    {
      key: "1",
      name: " Doe",
      usage: "2",
    },
    {
      key: "2",
      name: "John",
      usage: "2",
    },
    {
      key: "3",
      name: "Hello",
      usage: "8",
    },
    {
      key: "4",
      name: "John",
      usage: "2",
    },
    {
      key: "5",
      name: "World",
      usage: "3",
    },
    {
      key: "6",
      name: "John Doe",
      usage: "2",
    },
  ];

  const dataSourceYiminghe = [
    {
      key: "1",
      name: "Rim",
      usage: "1",
    },
    {
      key: "2",
      name: "ADoe",
      usage: "2",
    },
    {
      key: "3",
      name: "pc",
      usage: "7",
    },
    {
      key: "4",
      name: "Mouse",
      usage: "5",
    },
    {
      key: "5",
      name: "Rim",
      usage: "1",
    },
    {
      key: "6",
      name: "laptop",
      usage: "4",
    },
  ];
  const dataSourceAminities = [];
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState([]);
  const [subHeading, setSubHeading] = useState("");
  const [search, setSearch] = useState("");
 
  const handleTagTypeChange = (value) => {
    setLoading(true);
    switch (value) {
      case "jack":
        setDataSource(dataSourceJack);
        setSubHeading("Jack");
        break;
      case "lucy":
        setDataSource(dataSourceLucy);
        setSubHeading("Lucy");
        break;
      case "Yiminghe":
        setDataSource(dataSourceYiminghe);
        setSubHeading("Yiminghe");
        break;
      case "aminities":
        setDataSource(dataSourceAminities);
        setSubHeading("Amenities");
        break;
      default:
        setDataSource([]);
    }
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const hasSelected = selectedRowKeys.length > 0;

  const filteredData = dataSource.filter(
    (data) =>
      data.name.toLowerCase().includes(search.toLowerCase()) ||
      data.usage.toLowerCase().includes(search.toLowerCase())
  );

  const ReceivablePaymentsRightBar = [];

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      width: "60%",
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Usage",
      dataIndex: "usage",
      key: "usage",
      width: "30%",
      sorter: (a, b) => a.usage - b.usage,
    },
    {
      key: "operation",
    },
  ];
  const [expended, setExpended] = useState();
  const [isRename, setIsRename] = useState(false);

  const expend = (index) => {
    if (expended === index) setExpended(undefined);
    else setExpended(index);
  };

  const onFinish = (values) => {
    console.log("Success:", values);
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  function renderTable(data) {
    return (
      <>
        {isRename ? (
          <Form
            name="basic"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            layout="vertical"
          >
            <Row>
              <Col span={24} style={{ display: "none" }}>
                <Form.Item name="key">
                  <Input value={data.key} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item label="Tag Name" name="TagName">
                  <Input
                    style={{ width: "100%" }}
                    defaultValue={data.name}
                    value={data.name}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Row gutter={16}>
                  <Col>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        onClick={() => setIsRename(false)}
                      >
                        Rename
                      </Button>
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item>
                      <Button onClick={() => setIsRename(false)}>Cancel</Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        ) : (
          <Row>
            <Col>
              <Button type="link" onClick={() => setIsRename(true)}>
                Rename
              </Button>
            </Col>
            <Col>
              <Button type="text" style={{ color: "red" }}>
                Delete
              </Button>
            </Col>
          </Row>
        )}
      </>
    );
  }
  return (
    <div className="tagsPage">
      <div
        className="page-container"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div className="main-container" style={{ margin: "0px 20px" }}>
          <PageHeading heading="Manage Tags" />
          <Row gutter={[0, 12]}>
            <Col span={10}>
              <label style={{ fontSize: "1em", fontWeight: "300" }}>
                Tag Type
              </label>
              <Select
                style={{
                  width: "100%",
                  marginTop: "7px",
                  fontSize: "0.9em",
                  fontWeight: "300",
                  color: "gray",
                }}
                defaultValue="aminities"
                onChange={handleTagTypeChange}
                dropdownStyle={{ zIndex: 99999 }}
              >
                <Option value="aminities">Amenities</Option>
                <Option value="jack">Jack</Option>
                <Option value="lucy">Lucy</Option>
                <Option value="Yiminghe">yiminghe</Option>
              </Select>
            </Col>
            <Col span={24}>
              <SubHeading subHeading={subHeading} />
            </Col>
            {loading ? (
              <Col
                span={24}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <LoadingOutlined style={{ color: "gray", fontSize: "40px" }} />
              </Col>
            ) : (
              <Col span={24}>
                {dataSource.length ? (
                  <Col span={24}>
                    <Col span={10}>
                      <label style={{ fontSize: "1em", fontWeight: "300" }}>
                        Search Tags
                      </label>
                      <br></br>
                      <Search
                        style={{
                          width: "100%",
                          marginTop: "7px",
                          fontSize: "0.9em",
                          fontWeight: "300",
                          color: "gray",
                        }}
                        placeholder="Search by tag name"
                        onChange={(e) => setSearch(e.target.value)}
                      />
                    </Col>
                    <Col span={16}></Col>
                    <Col
                      span={8}
                      style={{
                        margin: "20px 0px",
                      }}
                    >
                      <Radio.Group buttonStyle="solid">
                        <Radio.Button
                          disabled
                          style={{ background: "##edf0f2", cursor: "text" }}
                        >
                          Bulk Actions
                        </Radio.Button>
                        <Radio.Button
                          value="mergeTags"
                          disabled={hasSelected ? false : true}
                          style={{ color: "#006eb7" }}
                        >
                          Merge Tags
                        </Radio.Button>
                        <Radio.Button
                          value="delete"
                          disabled={hasSelected ? false : true}
                          style={{ color: "red" }}
                        >
                          Delete
                        </Radio.Button>
                      </Radio.Group>
                    </Col>
                    <div className="table-container">
                      <Table
                        rowSelection={rowSelection}
                        columns={columns}
                        dataSource={filteredData}
                        expandIcon={({ expanded, onExpand, record }) =>
                          expanded ? (
                            <UpOutlined onClick={(e) => onExpand(record, e)} />
                          ) : (
                            <DownOutlined
                              onClick={(e) => onExpand(record, e)}
                            />
                          )
                        }
                        expandable={{
                          expandedRowRender: (record) => (
                            <p style={{ margin: 0 }}>{renderTable(record)}</p>
                          ),
                        }}
                        expandIconColumnIndex={columns.length} // specify the index of the last column
                        footer={false}
                      />
                    </div>
                  </Col>
                ) : (
                  <Col
                    span={24}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      fontSize: "1em",
                      fontWeight: "300",
                    }}
                  >
                    There are no amenities to display.
                  </Col>
                )}
              </Col>
            )}
          </Row>

          <Footer />
        </div>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={ReceivablePaymentsRightBar} />
      </div>
    </div>
  );
};
export default Tags;
